export const statusKeys = [
    "status",
    "txn_status",
    "txnStatus",
    "refund_txn_status",
    "src_status",
    "ap_refund_txn_status",
    "transfer_status",
    "final_status",
    "recon_status"
  ];
  
  export const tableDataFilter = (activeTab, data) => {
    switch (activeTab) {
      case "ALL":
        return data;
      case activeTab:
        return data?.filter((item) =>
          statusKeys.some((key) => item[key] === activeTab)
        );
      default:
        return data;
    }
  };
  
  export const commonDataTableColumnProps = {
    wrap: true,
    reorder: true,
    isChecked: true,
    sortable: true,
  };  